import React from 'react';
import { Card, Button, Divider, Tag} from 'antd';
import pluginVideo from './plugin.jpg';
import { PluginDetailSlider } from './plugin-detail__slider'
import { PluginDetailInfo } from './plugin-detail__info'

const extensionBinaryUrl = 'https://ml-extension-dist-1258148724.cos.ap-guangzhou.myqcloud.com/damai-extension_latest_.zip'

export const PluginDetail = () => (
    <div className='tw-flex tw-justify-center tw-w-full tw-bg-white'>
        <div className='tw-m-8'>
        <Card className='tw-w-[800px] '>
            <div>
                <PluginDetailInfo/>
                <Divider/>

                <video width="100%" controls>
                    <source src={pluginVideo} type="video/mp4"/>
                </video>

                <Divider/>
                <div>
                    <div className='tw-text-2xl tw-my-4'>DM插件的主要功能</div>
                    <div className='tw-my-8'> DM插件可以帮助卖家最快地验证产品机会。只需一键点击插件，即可轻松获取大量的产品和市场数据，分析产品的市场需求、竞争情况、销量趋势以及利润等数据。结合大麦数据网页版一起使用，可以找到海量产品机会，提升运营效率和效果</div>
                    <div className='tw-flex tw-flex-row tw-p-2'>
                        <div className='tw-p-4 tw-flex-1 tw-flex tw-flex-row'>
                            <div className='tw-mr-2'>
                                <div className='tw-bg-dm-orange 
                                    tw-w-[2em]
                                    tw-h-[2em]
                                    tw-rounded-full
                                    tw-flex
                                    tw-items-center
                                    tw-justify-center
                                    tw-text-white
                                    '>1</div>
                            </div>
                            <div>
                                <div className='tw-font-bold tw-mb-2'>节省90%的时间</div>
                                <div>选品使用插件，一键点击，即可节省您大量的时间和精力，快速验证产品机会，提升选品效率达90%以上！</div>
                            </div>
                        </div>
                        <div className='tw-p-4 tw-flex-1 tw-flex tw-flex-row'>
                            <div className='tw-mr-2 '>
                                <div className='tw-bg-dm-orange 
                                    tw-w-[2em]
                                    tw-h-[2em]
                                    tw-rounded-full
                                    tw-flex
                                    tw-items-center
                                    tw-justify-center
                                    tw-text-white
                                    '>2</div>
                            </div>
                            <div>
                                <div className='tw-font-bold tw-mb-2'> 验证产品机会</div>
                                <div>通过大麦数据独家研发的业界最精准的算法，实时抓取美客多前台产品数据信息，包含价格、排名、销售历史、上架时间等丰富信息。</div>
                            </div>
                        </div>
                    </div>

                    <Divider/>

                    <div className='tw-w-full '>
                        <PluginDetailSlider/>
                    </div>
                    <Divider/>
                    <div className='tw-flex tw-flex-col tw-items-center '>
                        <div>如果您也想提升选品效率和成功率，赶快尝试使用DM插件!</div>
                        <Button type="primary" className='tw-my-4 '>
                            <a href={extensionBinaryUrl} download='damai-extension.zip'>
                                获取DM插件!
                            </a>
                        </Button>
                    </div>
                </div>
            </div>
        </Card>
        </div>
    </div>
)
